<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p25"><span><a id="page_20"></a><a href="#/Contents#rp25">HOT-AND-SOUR CABBAGE SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="22" src="images/45.jpg" width="22"/></span></p>
<p class="normal"><span><i>Reminiscent of classic Chinese hot-and-sour soup, this version cooks in under 15 minutes.</i></span></p>
<p class="make"><span>4 first-course servings</span></p>
<p class="hang"><span>1 large carrot, coarsely shredded</span></p>
<p class="hang"><span>¼ cup finely chopped red bell pepper</span></p>
<p class="hang"><span>1½ teaspoons canola oil</span></p>
<p class="hang"><span>3 cups shredded green cabbage</span></p>
<p class="hang"><span>1 large garlic clove, minced</span></p>
<p class="hang"><span>1 tablespoon minced gingerroot</span></p>
<p class="hang"><span>4 green onions, thinly sliced, divided</span></p>
<p class="hang"><span>2 quarts reduced-sodium fat-free chicken broth</span></p>
<p class="hang"><span>1½ tablespoons apple cider vinegar</span></p>
<p class="hang"><span>1 tablespoon plus</span></p>
<p class="hang"><span>1 teaspoon light brown sugar</span></p>
<p class="hang"><span>3 tablespoons reduced-sodium soy sauce</span></p>
<p class="hang"><span>½ teaspoon Oriental hot chili oil</span></p>
<p class="hang"><span>2 tablespoons cornstarch</span></p>
<p class="normalt"><span><b>1.</b> Sauté carrot and bell pepper in oil in large saucepan 2 minutes. Add cabbage, garlic, gingerroot, and half the green onions; sauté until cabbage is tender, about 8 minutes. Add broth and heat to boiling; reduce heat and simmer, covered, 5 minutes. Stir in combined remaining ingredients, stirring until thickened, about 1 minute. Garnish each bowl of soup with remaining green onions.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 81</span></p>
<p class="per1"><span>% calories from fat: 21</span></p>
<p class="per1"><span>Protein (g): 6.2</span></p>
<p class="per1"><span>Carbohydrate (g); 10.8</span></p>
<p class="per1"><span>Fat (g): 2</span></p>
<p class="per1"><span>Saturated fat (g): 0 3</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 635</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 2.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter027.vue?4a21334f